/**
 * 这里记录了全局通用的枚举，如 ad_type network_type 等
 */

export const AD_TYPE = {
    RV: 94,
    IV: 287,
}

// 表示获取模板开关的方式，当前值表示从html代码段声明的全局变量中获取，全局变量中的模板开关由服务端通过预置的宏标记处理填充
export const MTG_AD_OPTIONS_FETCH_METHOD_MACRO = 'macro';